var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionsCircles = function SvgActionsCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 360,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 396,
    height: 396,
    x: -18,
    y: -18
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(9px)",
      clipPath: "url(#actions-circles_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 18
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 180,
    fill: "#a6e8ff",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 178,
    stroke: "url(#actions-circles_svg__b)",
    strokeOpacity: 0.7,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 333.903,
    height: 333.903,
    x: 13.049,
    y: 13.046
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(9px)",
      clipPath: "url(#actions-circles_svg__c)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 18
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.001,
    cy: 179.997,
    r: 148.951,
    fill: "#a6e8ff",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.001,
    cy: 179.997,
    r: 146.951,
    stroke: "url(#actions-circles_svg__d)",
    strokeOpacity: 0.4,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 268.388,
    height: 268.388,
    x: 45.806,
    y: 45.805
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(9px)",
      clipPath: "url(#actions-circles_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 18
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 179.999,
    r: 116.194,
    fill: "#a6e8ff",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 179.999,
    r: 114.194,
    stroke: "url(#actions-circles_svg__f)",
    strokeOpacity: 0.5,
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "actions-circles_svg__b",
    x1: 180,
    x2: 180,
    y1: 0,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3bbeec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3bbeec",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bbeec",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "actions-circles_svg__d",
    x1: 180.001,
    x2: 180.001,
    y1: 31.046,
    y2: 328.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3bbeec",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3bbeec",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bbeec",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "actions-circles_svg__f",
    x1: 180,
    x2: 180,
    y1: 63.805,
    y2: 296.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3bbeec",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3bbeec",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bbeec",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "actions-circles_svg__a",
    transform: "translate(18 18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 180
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "actions-circles_svg__c",
    transform: "translate(-13.05 -13.046)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.001,
    cy: 179.997,
    r: 148.951
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "actions-circles_svg__e",
    transform: "translate(-45.806 -45.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 179.999,
    r: 116.194
  })))));
};
export default SvgActionsCircles;